import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { faHospital } from '@fortawesome/pro-regular-svg-icons/faHospital'

export default function ClinicLocationHeader({
  clinicName,
  title,
  trialLocationImageId,
}: {
  clinicName: string
  title: string
  trialLocationImageId?: string
}) {
  return (
    <div className='flex flex-row items-center gap-1'>
      <div className='flex size-10 items-center justify-center rounded-full border-2 border-white bg-neutral400'>
        {trialLocationImageId ? (
          <div className='size-10 flex-none'>
            <CloudflareImage
              alt={clinicName}
              className={'size-10 rounded-full object-contain'}
              height={400}
              imageId={trialLocationImageId}
              priority={false}
              width={400}
            />
          </div>
        ) : (
          <div className='flex size-10 flex-none items-center justify-center rounded-full bg-neutral100'>
            <Icon className='text-primary600' icon={faHospital} size='1x' />
          </div>
        )}
      </div>
      <div className='flex flex-col items-start gap-0'>
        <div className='text-sm font-medium uppercase'>{title}</div>
        <div className='text-lg font-bold'>{clinicName ?? ''}</div>
      </div>
    </div>
  )
}
